var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',[_c('v-main',[_c('div',{staticClass:"html-content"},[_c('router-view')],1),_vm._v(" "),_c('tasks-center')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }